
const classPrefix = 'product'
const dataPrefix = 'data-product'

const $container = document.querySelector(`[${dataPrefix}]`)

if ($container) {
    product();
}

export function product() {

}
